/**
 * معناهای مشترکِ حضور و غیاب — یک‌جا، چون قبلاً هر تب نسخهٔ خودش را داشت و
 * وقتی یکی عوض می‌شد، بقیه بی‌صدا با معنیِ قدیمی می‌ماندند.
 */
export const STATUS_META = {
  before_hire: { label: "پیش از استخدام", color: "default" },
  after_leave: { label: "بعد از ترک کار", color: "default" },
  future: { label: "هنوز نیامده", color: "default" },
  absent: { label: "غایب", color: "error" },
  incomplete: { label: "ناقص", color: "warning" },
  multi_punch: { label: "۳+ تردد", color: "orange" },
  holiday_penalty: { label: "جریمهٔ تعطیل", color: "volcano" },
  normal: { label: "عادی", color: "success" },
  holiday: { label: "تعطیل", color: "default" },
  // تصمیمِ «بدونِ کسر / مأموریت / جایگزین» روی غیبت (v2.112.0) — روزِ پرداختی
  excused: { label: "بخشیده (بدونِ کسر)", color: "cyan" },
  reviewed: { label: "بازبینی‌شده", color: "blue" },
};
export const stMeta = (s) => STATUS_META[s] || { label: s, color: "default" };

export const MISSING_HINT = {
  entry: "احتمالاً ورود ثبت نشده",
  exit: "احتمالاً خروج ثبت نشده",
  unknown: "ورود/خروج ناقص؛ نیازمند بررسی",
};

/** تصمیم‌های بازبینی (قابلِ ویرایش تا نهایی‌سازیِ ماه) */
export const REVIEW_DECISIONS = [
  { v: "approved", l: "تأیید شد" },
  { v: "missing_entry", l: "ورود فراموش شده" },
  { v: "missing_exit", l: "خروج فراموش شده" },
  { v: "excused_absence", l: "غیبت موجه (بدونِ کسر)" },
  { v: "unexcused_absence", l: "غیبت غیرموجه (کسر می‌شود)" },
  // v2.152.9: آمده ولی کلِ روز غیبت حساب شود (به‌جای کسرکارِ سنگین‌تر)
  { v: "full_absence", l: "غیبتِ کامل (به‌جای کسرکار)" },
  { v: "mission", l: "مأموریت (بدونِ کسر)" },
  { v: "replacement_sent", l: "جایگزین داشته (بدونِ کسر)" },
  { v: "corrected", l: "اصلاح دستی انجام شد" },
  { v: "ignored", l: "بخشیده — بدونِ کسر از حقوق" },
];

/** روزِ «حل‌شده»: اصلاح دستی یا تصمیمِ بازبینیِ گرفته‌شده */
export const isResolved = (d) =>
  !!(d.resolved ?? (d.reviewed || d.review_status || d.is_manual));

export const rowClass = (r) => {
  if (isResolved(r)) return "att-row-resolved";
  return { absent: "att-row-absent", incomplete: "att-row-warn",
           multi_punch: "att-row-warn", holiday_penalty: "att-row-volcano" }[r.status] || "";
};

/** ارقامِ فارسی بدونِ جداکنندهٔ هزارگان — «۱۴۰۵» نه «۱٬۴۰۵» */
export const fa = (n) => String(n ?? 0).replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);

/** دقیقه → «ساعت:دقیقه» با ارقامِ فارسی — قالبِ فرمِ چاپیِ دستگاه (۱۶۲:۳۶) */
export const hhmm = (minutes) => {
  const m = Math.max(0, Math.round(Number(minutes) || 0));
  return `${fa(Math.floor(m / 60))}:${fa(String(m % 60).padStart(2, "0"))}`;
};

/** دقیقه → «۱۲۵ دقیقه (۲:۰۵)» — کاربر خواست کسرکار هم دقیقه باشد هم ساعت */
export const minutesLabel = (minutes) => {
  const m = Math.max(0, Math.round(Number(minutes) || 0));
  if (!m) return "—";
  return m < 60 ? `${fa(m)} دقیقه` : `${fa(m)} دقیقه (${hhmm(m)})`;
};

/**
 * سه تیکِ بالای کاردکس (۱۴۰۵/۰۷/۰۱): «فقط غیبت‌ها»، «خطای تردد» (کمتر یا بیشتر از دو
 * تردد — باید ترددِ اضافه کنار برود یا جاافتاده اضافه شود) و «کسری‌دار».
 * «غیبت» جریمهٔ مجاورتِ تعطیل را هم می‌گیرد: آن جریمه **به‌خاطرِ** غیبتِ چسبیده است.
 */
export const DAY_FILTERS = [
  { key: "absent", label: "غیبت‌ها", color: "error",
    help: "روزهای غایب و جریمهٔ تعطیلِ مجاور",
    test: (d) => ["absent", "holiday_penalty"].includes(d.status) },
  { key: "punch", label: "خطای تردد", color: "orange",
    help: "یک تردد (ورود یا خروج جاافتاده) یا ۳ تردد و بیشتر — با «ورود/خروج» اصلاح کنید",
    test: (d) => ["incomplete", "multi_punch"].includes(d.status) },
  { key: "shortage", label: "کسری‌دار", color: "red",
    help: "روزهایی که دیرکرد/تعجیلِ بیش از تلورانس دارند",
    test: (d) => (d.shortage_minutes || 0) > 0 },
];
